import TratamentePardoseli from "pages/Servicii/ServiciiCuratenie/TratamentePardoseli";

export default function TratamentePardoseliPage() {
    return <TratamentePardoseli />;
}
